export default {
  title: "Configuration",
  subtitle: "System configuration settings",

  breadcrumbs: {
    settings: "Settings",
    configuration: "Configuration"
  },

  fields: {
    buyForMeRate: "Buy For Me Rate",
    shipForMeRate: "Ship For Me Rate",
    tax: "Tax (%)",
    minimumBuyForMeCost: "Minimum Service Cost",
    minimumPartialPaymentPercentage: "Minimum Partial Payment Percentage (%)",
    enableBuyForMe: "Enable Buy For Me",
    enableShipForMe: "Enable Ship For Me",
    approvedOrderResetHours: "Approved Order Auto-Cancel (Hours)",
    minimumOrderWeight: "Minimum Order Weight (LB)",
    maximumOrdersPerCreate: "Maximum Items Per Order"
  },

  placeholders: {
    buyForMeRate: "Enter buy for me rate",
    shipForMeRate: "Enter ship for me rate",
    tax: "Enter tax percentage",
    minimumBuyForMeCost: "Enter minimum cost",
    minimumPartialPaymentPercentage: "Enter minimum partial payment percentage",
    approvedOrderResetHours: "Enter number of hours (e.g. 72)",
    minimumOrderWeight: "Enter minimum weight in LB (e.g. 0.5)",
    maximumOrdersPerCreate: "Enter the maximum number of items (e.g. 10)"
  },

  messages: {
    updateSuccess: "Configuration updated successfully!",
    updateError: "Error updating configuration",
    loadingError: "Error loading configuration",
    loading: "Loading configuration details..."
  },

  actions: {
    update: "Update Configuration",
    updating: "Updating...",
    back: "Back"
  },

  validation: {
    buyForMeRateRequired: "Buy for me rate is required",
    shipForMeRateRequired: "Ship for me rate is required",
    taxRequired: "Tax is required",
    minimumCostRequired: "Minimum cost is required",
    invalidNumber: "Please enter a valid number",
    negativeNumber: "Value cannot be negative",
    maximumOrdersPerCreate: "Maximum items per order must be a positive whole number"
  },
  onboarding: {
    title: "Onboarding Steps Order",
    subtitle: "Drag and drop to change the display order for customers",
    steps: {
      profile: "Update Profile",
      createOrder: "Create Order",
      dashboard: "Dashboard Sidebar",
      orderKinds: "Order Kinds Info",
      orders: "Buy4Me Orders Sidebar",
      shipForMe: "ShipForMe Sidebar"
    }
  }
};
